export const LANGUAGE_AUTO_DETECT = 'auto';
export const SUPPORTED_LANGUAGES = ['en', 'ja', 'zh', 'auto'] as const; // Example: English, Japanese, Spanish
export type Language = typeof SUPPORTED_LANGUAGES[number];

export const LANGUAGE_NAMES: { [key: string]: string } = {
  'en': 'English',
  'ja': 'Japanese',
  'zh': "Chinese",
  'auto': "auto-detect"
}

type ThemeType = {
  containerBackgroundColor: string;
  containerBackgroundImage?: string;
  chatBackgroundColor: string;
  chatBackgroundImage?: string;
  headerBackgroundColor: string;
  headerBackgroundImage?: string;
  containerBorderColor?: string;
  primaryColor?: string;
  //
  primaryFontColor?: string;
  primaryMessageBackground?: string;
  chatBubbleColors?: string[];
  // Language-specific styles
  languageStyles?: Record<string, React.CSSProperties>;
}

export interface ConversationSetting {
  contextInput: string;
  presetOption: string;
}

export const PRESET_PROMPT_CONTEXT_VALUES: Record<string, string> = {
  tourism: "The conversation is between travelers and locals or tour guides discussing tourist information, directions, recommendations for places to visit, local customs, and travel tips.",
  work: "The conversation is between colleagues or business partners discussing work-related topics, business terminology, formal communication, and professional matters.",
  casual: "The conversation is between friends or acquaintances having everyday casual conversations, small talk, and informal discussions.",
  dating: "The conversation is between people on a date or getting to know each other romantically, including compliments and social interactions.",
}

/**
 * Config type representing config json for whitelabeling clients
*/
export interface ClientConfig {
  matcher: {
    roomId?: string; // can be regex or exact
    subDomains?: string[];
    cname?: string;
  };
  config: {
    name: string;
    logo: string;
    logoDark?: string;
    logoWidth?: number;
    roomPrefix?: string;
    defaultTheme: string;
    features: Record<string, boolean>;
    excludeInterfaceLangaugeFromTarget?: boolean;
    disableLogoInLoginPage?: boolean;
    endpoints?: {
      srt?: string;
    }
    prompts?: {
      transcriptionContext?: string;
      context?: string
      hint?: string
    }
  };
  theme?: {
    dark?: ThemeType | {};
    light?: ThemeType | {};
  };
  fontSize?: string;
}

export interface PresentationSettings {
  vadEnabled: boolean;
  fontSize: string;
  sidePanelOpen: boolean;
}

export interface ClientSetPresentationSettingsMessage {
  type: 'setPresentationSettings';
  settings: Partial<PresentationSettings>;
  roomId: string;
}

export interface ServerSetPresentationSettingsMessage {
  type: 'setPresentationSettings';
  settings: Partial<PresentationSettings>;
  timestamp: number;
}
